<template>
  <div>
    <div class="header mb-4">
      <h1 class="header-title">Order #{{ $route.params.id }}</h1>
      <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <a href="#">Dashboard</a>
          </li>
          <li class="breadcrumb-item">
            <a href="#">Orders</a>
          </li>
          <li class="breadcrumb-item active" aria-current="page">
            Order Details
          </li>
        </ol>
      </nav>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body" v-if="!loading">
            <div class="row">
              <div class="col-md-9">
                <button class="btn btn-info float-end">
                  Status: {{ order.status }}
                </button>
                <h4>Order Details</h4>
                <hr />
                <div class="row">
                  <div class="col-md-6">
                    <label>Content Type</label>
                    <p>{{ order.type.name }}</p>
                  </div>
                  <div class="col-md-6">
                    <label>Content Category</label>
                    <p>{{ order.category.name }}</p>
                  </div>
                  <div class="col-md-12">
                    <label>Title</label>
                    <p>{{ order.title }}</p>
                  </div>
                  <div class="col-md-12">
                    <label>Instructions</label>
                    <p>{{ order.instructions }}</p>
                  </div>
                  <div class="col-md-12" v-if="order.examples.length > 0">
                    <label>Examples</label>
                    <div class="row">
                      <div
                        class="col-md-6"
                        v-for="(example, i) in order.examples"
                        :key="`example-${i}`"
                      >
                        <p>{{ example }}</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="order.status == 'in-progress'">
                  <hr />
                  <h4>Submit Order</h4>
                  <form @submit.prevent="update" id="update_form">
                    <div class="mb-3">
                      <label>Upload Completed Document For Admin Review</label>
                      <input
                        type="file"
                        ref="completed_order"
                        class="form-control"
                        name="document"
                      />
                    </div>
                    <div class="mb-3">
                      <button class="btn btn-primary">
                        <i class="fal fa-save"></i>Submit
                      </button>
                    </div>
                  </form>
                </div>
                <div v-if="order.status == 'pending-review'">
                  <hr />
                  <h4>Order Pending Admin Review</h4>
                  <p>
                    Document:
                    <a
                      :href="order.assignment.document"
                      target="_blank"
                      class="btn btn-secondary ms-2"
                      ><i class="fal fa-download"></i>Download</a
                    >
                  </p>
                  <p>Submitted On: {{ order.assignment.completed_at }}</p>
                </div>
                <div v-if="order.status == 'review'">
                  <hr />
                  <h4>Order Pending Client Review</h4>
                  <p>
                    Assigned To: {{ order.assignment.name }}
                    <small>({{ order.assignment.email }})</small>
                  </p>
                  <p>Assigned On: {{ order.assignment.date }}</p>
                  <p>
                    Document:
                    <a
                      :href="order.assignment.document"
                      target="_blank"
                      class="btn btn-secondary ms-2"
                      ><i class="fal fa-download"></i>Download</a
                    >
                  </p>
                  <p>Completed On: {{ order.assignment.completed_at }}</p>
                </div>
                <div v-if="order.status == 'complete'">
                  <hr />
                  <h4>Order Complete</h4>
                  <p>
                    Assigned To: {{ order.assignment.name }}
                    <small>({{ order.assignment.email }})</small>
                  </p>
                  <p>Assigned On: {{ order.assignment.date }}</p>
                  <p>
                    Document:
                    <a
                      :href="order.assignment.document"
                      target="_blank"
                      class="btn btn-secondary ms-2"
                      ><i class="fal fa-download"></i>Download</a
                    >
                  </p>
                  <p>Completed On: {{ order.assignment.completed_at }}</p>
                </div>
                <hr />
                <div>
                  <h4>Timeline and Notes</h4>
                  <section class="py-2">
                    <ul class="timeline">
                      <li class="timeline-item mb-5" v-for="(line, i) in order.timeline" :key="`line-${i}`">
                        <h5 class="fw-bold">{{ line.title }}</h5>
                        <p class="text-muted mb-2 fw-bold">{{ line.date }}</p>
                        <p class="text-muted">{{ line.message }}</p>
                        <p class="text-muted" v-if="line.penalty > 0">Penalty: KES {{ line.penalty }}</p>
                      </li>
                    </ul>
                  </section>
                </div>
              </div>
              <div class="col-md-3">
                <div class="card shadow">
                  <div class="card-body">
                    <h4><i class="far fa-shopping-cart"></i> Order Info</h4>
                    <hr />
                    <div>
                      <p class="mb-0">
                        <strong class="me-2">Quality:</strong>
                        <quality :quality="order.quality" />
                      </p>
                      <p>{{ order.quality.name }}</p>
                    </div>
                    <div>
                      <p class="mb-0">
                        <strong class="me-2">Word Count:</strong>
                      </p>
                      <p>Min: {{ order.min }}, Max: {{ order.max }}</p>
                    </div>
                    <div>
                      <p class="mb-0">
                        <strong class="me-2">Assigned:</strong>
                      </p>
                      <p>{{ order.assignment.date }}</p>
                    </div>
                    <div>
                      <p class="mb-0">
                        <strong class="me-2">Expected Delivery:</strong>
                      </p>
                      <p>
                        {{ order.assignment.expected }} ({{
                          order.assignment.hours
                        }}
                        Hours)
                      </p>
                    </div>
                    <hr />
                    <div>
                      <h3>Payment: <small>KES</small>{{ order.assignment.payment }}</h3>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <loading v-if="loading" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    this.fetch();
  },

  data() {
    return {
      order: {},
      loading: true,
      writers: [],
      selected_writer: null,
      reassign: false,
    };
  },

  methods: {
    fetch() {
      this.loading = true;

      this.$axios
        .get(`/api/v1/writer/orders/${this.$route.params.id}`)
        .then((response) => {
          this.order = response.data.order;
          this.writers = response.data.writers;
          this.loading = false;
        });
    },

    update() {
      let data = new FormData();
      data.append("form_id", "update_form");
      data.append("action", "update");
      data.append("_method", "PUT");

      if (this.$refs.completed_order.files[0]) {
        data.append("document", this.$refs.completed_order.files[0]);
      }

      this.$axios
        .post(`/api/v1/writer/orders/${this.$route.params.id}`, data, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then(() => {
          this.$toast.success("The order has been sent for review.");
          this.fetch();
        });
    },
  },
};
</script>
